{
  "nav": "サーバールーム",
  "title": "サーバールーム",
  "subtitle": "サーバールーム管理ステーションから報告された、ネットワーク・Wi-Fi アクセスポイント・サーバー・NAS の状態です（閲覧のみ）。",
  "loading": "読み込み中…",
  "not_found": "表示できるサーバールームがありません。",
  "col": {
    "site": "ロケーション",
    "station": "サーバールーム管理ステーション",
    "online": "接続状態"
  },
  "online": "オンライン",
  "offline": "オフライン",
  "tab": {
    "overview": "概要",
    "router": "ルーター",
    "ap": "Wi-Fi アクセスポイント",
    "servers": "サーバー",
    "nas": "NAS"
  },
  "tool": {
    "site.status": "概要",
    "net.devices": "接続中のデバイス",
    "net.wan": "インターネット接続",
    "net.wifi": "Wi-Fi",
    "net.traffic": "トラフィック",
    "net.dhcp.list": "固定 IP",
    "net.forward.list": "ポート転送",
    "net.logs": "ログ",
    "ap.status": "状態",
    "ap.clients": "接続中のクライアント",
    "ap.wifi": "Wi-Fi 設定",
    "srv.health": "サーバー",
    "nas.health": "NAS"
  },
  "refresh": "再読み込み",
  "running": "問い合わせ中…",
  "updated": "{{at}} に更新",
  "wait": "（{{s}} 秒お待ちください）",
  "error": "問い合わせに失敗しました：{{code}}",
  "run_state": "問い合わせが完了しませんでした：{{state}} {{code}}",
  "no_resources": "このサーバールーム管理ステーションには、この種類のデバイスが登録されていません。"
}
